const formatProductTitle = (title, productOptions) => {
  // eslint-disable-next-line prefer-const
  let productTitle = title;
  // eslint-disable-next-line no-unused-vars
  const productColor = productOptions.find((option) => option.name === 'Color');

  // uncomment the code when the corresponding functionality appears

  // if (productColor) {
  //   // We're either checking a product object or line_item object
  //   const [value] = Object.hasOwn(productColor, 'values')
  //     ? productColor.values
  //     : [productColor.value];
  //   productTitle = productTitle.replace(value, '').trim();
  // }

  return productTitle;
};

export default formatProductTitle;
